import { render, staticRenderFns } from "./TaskDetailHeader.vue?vue&type=template&id=33089ef5&lang=pug"
import script from "./TaskDetailHeader.vue?vue&type=script&lang=js"
export * from "./TaskDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports